import React, { useEffect, useState } from "react";
import { IonItem, IonIcon, IonLabel, IonItemDivider } from "@ionic/react";
import { menuController } from "@ionic/core";
import { getCurrentUser } from "../../services/auth";
import { useHistory, useParams } from "react-router";
import { getAuth, onAuthStateChanged } from "firebase/auth";

import {
	calendarOutline,
	home,
	people,
	peopleOutline,
	settingsOutline,
	statsChartOutline,
} from "ionicons/icons";
import { connect } from "react-redux";

interface Props {
	user: any;
	users: any;
	currentID: any;
}

const FrontendMenu: React.FC<Props> = ({ user, users, currentID }) => {
	const [current, setCurrent] = useState<any>({});

	const closeMenu = async () => {
		await menuController.toggle();
	};

	useEffect(() => {
		if (users && users[currentID]) {
			setCurrent(users[currentID]);
		}
	}, [users, currentID]);

	return (
		<>
			<IonItem routerLink="/dashboard" onClick={closeMenu} lines="none">
				<IonIcon slot="start" icon={home}></IonIcon>
				<IonLabel>Dashboard</IonLabel>
			</IonItem>

			{user.isAdmin && (
				<IonItem routerLink="/dashboard" onClick={closeMenu} lines="none">
					<IonIcon slot="start" icon={peopleOutline}></IonIcon>
					<IonLabel>All Users</IonLabel>
				</IonItem>
			)}
			{user.isAdmin && currentID && current && (
				<>
					<IonItemDivider>
						<IonLabel>{current.displayName}</IonLabel>
					</IonItemDivider>
					<IonItem
						routerLink={`/users/${currentID}`}
						onClick={closeMenu}
						lines="none"
					>
						<IonIcon slot="start" icon={calendarOutline}></IonIcon>
						<IonLabel>Calendar</IonLabel>
					</IonItem>
					<IonItem
						routerLink={`/users/${currentID}/charts`}
						onClick={closeMenu}
						lines="none"
					>
						<IonIcon slot="start" icon={statsChartOutline}></IonIcon>
						<IonLabel>Charts</IonLabel>
					</IonItem>
					<IonItem
						routerLink={`/users/${currentID}/config`}
						onClick={closeMenu}
						lines="none"
					>
						<IonIcon slot="start" icon={settingsOutline}></IonIcon>
						<IonLabel>Config</IonLabel>
					</IonItem>
				</>
			)}
		</>
	);
};

const mapStateToProps = (state: any) => ({
	user: state.user.userDetails,
	users: state.user.users,
	currentID: state.user.current,
});

export default connect(mapStateToProps, {})(FrontendMenu);
